import React from 'react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Table } from '../../components/ui/Table';
import { Badge } from '../../components/ui/Badge';
import { Input } from '../../components/ui/Input';
import { Plus, Search, MapPin, Store } from 'lucide-react';
interface OutletRegistryProps {
  onMonitoringClick: () => void;
}
export function OutletRegistry({
  onMonitoringClick
}: OutletRegistryProps) {
  return <div className="space-y-6" data-id="element-867">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-868">
        <div data-id="element-869">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-870">
            Outlet & Mitra SPHP
          </h1>
          <p className="text-gray-500 mt-1" data-id="element-871">
            Database pengecer dan distributor resmi
          </p>
        </div>
        <div className="flex flex-wrap gap-2 w-full sm:w-auto" data-id="element-872">
          <Button variant="secondary" onClick={onMonitoringClick} icon={<Store size={18} data-id="element-874" />} className="flex-1 sm:flex-none" data-id="element-873">
            Monitoring Harga
          </Button>
          <Button icon={<Plus size={18} data-id="element-876" />} className="flex-1 sm:flex-none" data-id="element-875">
            Tambah Outlet
          </Button>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-877">
        <Card className="lg:col-span-2" data-id="element-878">
          <div className="flex flex-col sm:flex-row gap-4 mb-6" data-id="element-879">
            <div className="flex-1" data-id="element-880">
              <Input placeholder="Cari nama toko, pemilik, atau alamat..." leftIcon={<Search size={18} data-id="element-882" />} data-id="element-881" />
            </div>
            <Button variant="outline" className="w-full sm:w-auto" data-id="element-883">
              Filter Wilayah
            </Button>
          </div>
          <Table columns={[{
          header: 'Nama Toko',
          accessor: (item: any) => <div className="min-w-0" data-id="element-885">
                    <div className="font-semibold text-gray-900 truncate" data-id="element-886">
                      {item.name}
                    </div>
                    <div className="text-xs text-gray-500 mt-0.5" data-id="element-887">
                      {item.owner}
                    </div>
                  </div>
        }, {
          header: 'Wilayah',
          accessor: 'region',
          className: 'hidden md:table-cell'
        }, {
          header: 'Tipe',
          accessor: 'type',
          className: 'hidden lg:table-cell'
        }, {
          header: 'Status',
          accessor: (item: any) => <Badge variant="success" data-id="element-888">{item.status}</Badge>
        }]} data={[{
          name: 'Toko Berkah Jaya',
          owner: 'H. Ahmad',
          region: 'Pasar Kramat Jati',
          type: 'Pengecer',
          status: 'Aktif'
        }, {
          name: 'RPK Melati',
          owner: 'Ibu Susi',
          region: 'Tebet',
          type: 'RPK',
          status: 'Aktif'
        }, {
          name: 'Sumber Rejeki',
          owner: 'Bpk. Budi',
          region: 'Pasar Minggu',
          type: 'Pengecer',
          status: 'Aktif'
        }]} keyExtractor={i => i.name} data-id="element-884" />
        </Card>

        <Card title="Peta Sebaran Outlet" data-id="element-889">
          <div className="h-64 bg-gray-100 rounded-lg flex items-center justify-center relative overflow-hidden" data-id="element-890">
            <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#0056A6_1px,transparent_1px)] [background-size:16px_16px]" data-id="element-891"></div>
            <div className="text-center text-gray-400 z-10" data-id="element-892">
              <MapPin size={32} className="mx-auto mb-2" data-id="element-893" />
              <p className="text-sm font-medium" data-id="element-894">Peta Interaktif</p>
            </div>
            {/* Fake pins */}
            <div className="absolute top-1/4 left-1/3 w-3 h-3 bg-red-500 rounded-full border-2 border-white shadow-lg z-20" data-id="element-895"></div>
            <div className="absolute top-1/2 left-1/2 w-3 h-3 bg-red-500 rounded-full border-2 border-white shadow-lg z-20" data-id="element-896"></div>
            <div className="absolute bottom-1/3 right-1/4 w-3 h-3 bg-red-500 rounded-full border-2 border-white shadow-lg z-20" data-id="element-897"></div>
          </div>
          <div className="mt-4 space-y-3" data-id="element-898">
            <div className="flex justify-between items-center text-sm" data-id="element-899">
              <span className="text-gray-500" data-id="element-900">Total Outlet Aktif</span>
              <span className="font-bold text-gray-900 text-lg" data-id="element-901">1,250</span>
            </div>
            <div className="flex justify-between items-center text-sm" data-id="element-902">
              <span className="text-gray-500" data-id="element-903">Outlet Baru (Bulan Ini)</span>
              <span className="font-bold text-green-600 text-lg" data-id="element-904">+45</span>
            </div>
          </div>
        </Card>
      </div>
    </div>;
}